import ConditionSelectView from './src/conditionSelectView.vue';

/* istanbul ignore next */
ConditionSelectView.install = function(Vue) {
    Vue.component(ConditionSelectView.name, ConditionSelectView);
};

export default ConditionSelectView;